var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipChocolate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.48 2.43002C7.31002 -1.40998 -1.40998 7.31002 2.43002 16.48C3.39002 18.77 5.23002 20.62 7.52002 21.57C16.69 25.41 25.4 16.69 21.57 7.52002C20.61 5.23002 18.77 3.38002 16.47 2.43002H16.48ZM10.01 9.50002L11.96 7.55002L13.63 9.23002L11.69 11.18H11.68L10.01 9.50002ZM11.22 11.65L9.23002 13.64L7.55002 11.96L9.54002 9.97002L11.22 11.65ZM9.54002 9.03002L7.83002 7.32002L9.43002 5.72002C9.63002 5.52002 9.94002 5.52002 10.14 5.72002L11.5 7.08002L9.55002 9.03002H9.54002ZM9.07002 9.49002L7.08002 11.49L5.72002 10.13C5.52002 9.93002 5.52002 9.62002 5.72002 9.42002L7.36002 7.78002L9.07002 9.49002ZM10.22 15.36L9.33002 14.47L12.16 11.65L14.28 9.53002L14.47 9.33002L15.35 10.22L15.04 10.28L13.59 10.6L12.92 12.95L10.67 13.49L10.3 15.06L10.22 15.36ZM10.85 15.61L11.01 14.94L11.23 14.05L12.12 13.83L13.35 13.53L13.45 13.51L13.48 13.41L13.86 12.09L14.12 11.17L14.97 10.98L15.59 10.84L18.28 13.52C18.48 13.72 18.48 14.03 18.28 14.23L14.23 18.29C14.03 18.49 13.72 18.49 13.52 18.29L11.06 15.83L10.85 15.61Z",
    fill: "#7B3306"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipChocolate);
export default __webpack_public_path__ + "static/media/ic-chip-chocolate.2c2611277830c9abd620ca6b7496da5e.svg";
export { ForwardRef as ReactComponent };